export let removeFromFavoritesCategoryText = "a_XBgd";
export let removeFromFavoritesCategoryTextTeams = "si9wUd";
export default {removeFromFavoritesCategoryText,removeFromFavoritesCategoryTextTeams};